import React from 'react'
import { HashRouter, Switch, Route } from 'react-router-dom'
import './App.css'
import Home from './pages/Home'
import AddSupplier from './pages/AddSupplier'
import Header from './components/header/Header'
import NotFound from './pages/NotFound'
import { Container, ThemeProvider, Box } from '@material-ui/core'

import { customTheme } from './themes/CustomTheme'


function App() {
  return (
    <ThemeProvider theme={customTheme}>
      <HashRouter>
        <Header />
        <Container>    
          <Box className="main-content">              
            <Switch>
              <Route exact path="/" component={Home}/>
              <Route exact path="/supplier/add"  component={AddSupplier}/>
              {/*<Route component={NotFound} />*/}
            </Switch>        
          </Box>
        </Container>
      </HashRouter>
    </ThemeProvider>
  );
}

export default App;
